export default __webpack_public_path__ + "static/media/miguel_munoz.a0ee75c8.png";